<template>
    <v-card
        v-if="service.agency === null || !service.agency"
        class="rounded-xl ma-2 pa-8"
    >
        <v-card-title>
            Deposit
        </v-card-title>

        <v-text-field
            v-model="service.fixed_deposit"
            label="Fixed USD"
            class="ma-2 px-5"
            style="width: 200px"
            :rules="numberRule"
            :disabled="$store.getters.loadingApp === 1"
        />

        <v-text-field
            v-model="service.variable_deposit"
            label="Variable % of the price"
            class="ma-2 px-5"
            style="width: 200px"
            :rules="numberRule"
            :disabled="$store.getters.loadingApp === 1"
        />
    </v-card>
</template>

<script>
    import inputRules from '@/mixins/inputRules'
    
    export default {
        name: "ServiceDeposit",

        mixins: [
            inputRules,
        ],

        props: {
            service: {
                type: Object,
                default: () => ({}),
            },
        },
    }
</script>